import { Component, OnInit } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { RouterLink } from '@angular/router';
import { NgFor } from '@angular/common';
import { GroupService } from 'src/app/services/group.service';
import { ManagedTeamsOnlyLinkComponent } from '@components/permission-related/managed-teams-only-link/managed-teams-only-link.component';
import { IOrgUser } from 'src/app/services/user.service';

export interface PermissionTypeValuePack {
  permissionDisplayText: 'Team Manager' | 'Organisation Manager' | 'Learner' | 'Location Manager';
  managedTeam: {teamName: string; teamID: string}[];
}
@Component({
    selector: 'app-permission-type-column',
    templateUrl: './permission-type-column.component.html',
    styleUrls: ['./permission-type-column.component.scss'],
    imports: [NgFor, RouterLink, NgbPopover, ManagedTeamsOnlyLinkComponent]
})
export class PermissionTypeColumnComponent implements OnInit {

  rowData: IOrgUser;
  value: PermissionTypeValuePack;

  managedTeams: {teamName: string; teamID: string}[]
  managedLocations: {teamName: string; teamID: string}[]

  constructor(
    private groupService: GroupService
  ) { }

  ngOnInit(): void {
    this.managedTeams = this.value?.managedTeam?.filter(t => t && this.groupService.globalTeamsDict[t.teamID]);
    this.managedLocations = this.value?.managedTeam?.filter(t => t && !this.groupService.globalTeamsDict[t.teamID]);
  }

  get isTeamManager() {
    return this.value.permissionDisplayText === 'Location Manager' 
        || this.value.permissionDisplayText === 'Team Manager';
  }

  get role() {
    return this.rowData.profile?.privilege?.perfReviewRole;
  }

//   get routePrefix() {
//     return this.value.permissionDisplayText === 'Location Manager'
//         ? '/pages/admin/admin-locations'
//         : '/pages/admin/teams/single';
//   }

  getRoutePrefix(teamID) {
    if (this.groupService.globalTeamsDict[teamID]) {
        return '/pages/admin/teams/single';
    }
    return '/pages/admin/admin-locations';
  }
}
